import {
	useMenuExpandedContext,
} from '~/contexts/MenuExpandedContext';

/**
 * Hook to manage menu-initiated navbar expansion state
 *
 * When a user clicks a menu item in Phase 2 (mobile/responsive), this state
 * expands the navbar to Phase 3 (desktop) even on small screens.
 *
 * State does NOT persist across page reloads (resets to false).
 * State auto-clears when viewport naturally becomes Phase 3 (≥1169px).
 *
 * @returns Tuple of [isExpanded, setExpanded, isMinimized, setMinimized]
 */
function useMenuExpandedState(): [
	boolean,
	(expanded: boolean) => void,
	boolean,
	(minimized: boolean) => void,
	] {
	const { isExpanded, isMinimized, setExpanded, setMinimized } = useMenuExpandedContext();

	return [isExpanded, setExpanded, isMinimized, setMinimized];
}

export default useMenuExpandedState;
